module.exports = __webpack_public_path__ + "img/senior-bg.68662aac.png";